module.exports = __webpack_public_path__ + "static/media/validacao_qualquer_coisa_dark.63428719.svg";